import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogCopyActivityComponent } from '../modules/lessons/dialog-copy-activity/dialog-copy-activity.component';
import { DialogMessagesComponent } from '../modules/shared/components/dialog-messages/dialog-messages.component';
import {DialogActivityGradeComponent} from '../modules/lessons/dialog-activity-grade/dialog-activity-grade.component';
import {DialogGradeCourseComponent} from '../modules/lessons/dialog-grade-course/dialog-grade-course.component';
import { DialogPushMessageComponent } from '../modules/courses/dialog-push-message/dialog-push-message.component';
import { DialogModifyUserComponent } from '../modules/users/dialog-modify-user/dialog-modify-user.component';
import { DialogGradeCreatorComponent } from '../modules/lessons/dialog-grade-creator/dialog-grade-creator.component';

@Injectable({
  providedIn: 'root'
})
export class MessagesModalService {

  constructor(private dialog: MatDialog) { }

  openDialog(messageType?: string, messageTitle?: string, messageContent?: string | any): any {
    const dialogRef = this.dialog.open(DialogMessagesComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle,
        messageContent: messageContent
      }
    });

    return dialogRef;
  }

  openCopyActivityDialog(messageType?: string, messageTitle?: string): any {
    const dialogRef = this.dialog.open(DialogCopyActivityComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle
      }
    });

    return dialogRef;
  }

  openActivityGradeDialog(messageType?: string, messageTitle?: string, messageActivityId?:string): any {
    const dialogRef = this.dialog.open(DialogActivityGradeComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle,
        messageActivityId: messageActivityId
      }
    });

    return dialogRef;
  }

    openGradeCourseDialog(messageType?: string, messageTitle?: string,messageLessonId?:number): any {
      const dialogRef = this.dialog.open(DialogGradeCourseComponent, {
        width: '560px',
        data: {
          messageType: messageType,
          messageTitle: messageTitle,
          messageLessonId: messageLessonId
        }
      });

    return dialogRef;
  }

  openPushMessageDialog(messageType?:string,messageTitle?: string):any{
    const dialogRef = this.dialog.open(DialogPushMessageComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle,
      }
    });

    return dialogRef;
  }

  openModifyDialog(messageType?:string,messageTitle?:string,messageUserId?:number): any {
    const dialogRef = this.dialog.open(DialogModifyUserComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle,
        messageUserId: messageUserId
      }
    });

  return dialogRef;
  }

  openGradeCreatorDialog(messageType?:string,messageTitle?: string,messageActivityId?:string):any{
    const dialogRef = this.dialog.open(DialogGradeCreatorComponent, {
      width: '560px',
      data: {
        messageType: messageType,
        messageTitle: messageTitle,
        messageActivityId: messageActivityId
      }
    });

    return dialogRef;
  }

  
}
